import type { EventEmitter } from '@stencil/core';
import { getExternalOriginSessionStorageValue, removeCTAActionSessionStorageValue } from '../../conversational-search-logic/storage-manager/storage-manager-helpers';
import { externalOriginEndOfConversationHandler } from '../../conversational-search-logic/utils/utils';

const iconEventEmitter = (
  gaIconEventEmitter: EventEmitter<{ actionItem: string; keyword: string, isNotResponseAction: boolean }>,
  actionItem: string,
  query: string,
) => {
    gaIconEventEmitter.emit({
      actionItem,
      keyword: query,
      isNotResponseAction: true,
    });
};

export const selectCorrectExitRoute = (
  gaIconEventEmitter: EventEmitter<{ actionItem: string; keyword: string, isNotResponseAction: boolean }>,
  chatVisibilityEventEmitter: EventEmitter<{ isChatVisible: boolean }>,
  conversationalSearchBrandUrl: string,
  query: string,
  country: string,
  language: string,
) => {
    const closeChatIconName = 'Cross';

    iconEventEmitter(gaIconEventEmitter, closeChatIconName, query);

    if (getExternalOriginSessionStorageValue()) {
      removeCTAActionSessionStorageValue();
      externalOriginEndOfConversationHandler(
        conversationalSearchBrandUrl,
        country,
        language,
      );
    } else {
      chatVisibilityEventEmitter.emit({ isChatVisible: false });
    }
};

export const onNewConversationClickAction = (
  userStartingNewConversationEventEmitter: EventEmitter,
  gaIconEventEmitter: EventEmitter<{ actionItem: string; keyword: string, isNotResponseAction: boolean }>,
  query: string,
) => {
    const newConversationiconName = 'Plus circle';
    userStartingNewConversationEventEmitter.emit();
    iconEventEmitter(
      gaIconEventEmitter,
      newConversationiconName,
      query,
    );
};
